import PropTypes from 'prop-types';
import {CreateUpdateEntityView} from '@ozgene/gp5.components.create-update-entity-view';
import {useEffect, useState} from 'react';
import {create, findScheduleById} from 'Schedule/service/ScheduleService';
import ScheduleEditor from 'Schedule/components/ScheduleEditor';

export default function CreateUpdateScheduleView(props, context) {
  const {router} = context;
  const {
    params: {scheduleId},
  } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [entity, setEntity] = useState(null);
  const handleSave = async (schedule) => {
    await create(schedule);
    router.push('Schedules');
  };
  const handleRetrieveSchedule = async (scheduleId) => {
    if (scheduleId) {
      setEntity(await findScheduleById(scheduleId));
    }

    setIsLoading(false);
  };

  useEffect(() => {
    handleRetrieveSchedule(scheduleId);
  }, [scheduleId]);

  return (
    !isLoading && (
      <CreateUpdateEntityView
        entityType="Schedule"
        entity={entity}
        EditorComponent={ScheduleEditor}
        onSave={handleSave}
      />
    )
  );
}
CreateUpdateScheduleView.propTypes = {
  params: PropTypes.shape({
    scheduleId: PropTypes.string,
  }),
};
CreateUpdateScheduleView.contextTypes = {
  router: PropTypes.object.isRequired,
};
CreateUpdateScheduleView.defaultProps = {
  params: {scheduleId: null},
};
